/* eslint-disable @typescript-eslint/no-explicit-any */
import {useFocusEffect, useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import React, {useState} from 'react';
import {View} from 'react-native';
import {connect} from 'react-redux';

import {getNextDay, handleDateValue} from '../../../../common/utils/date';

import {getTypeContratPayment} from '../../../../common/utils/paiement';
import {Validation} from '../../../../common/utils/paiement/validationAirtel';
import {separateurMillier} from '../../../../common/utils/rendering';
import config from '../../../../data/config';
import {
  defaultAirtelMoneyErrorValues,
  ERROR_MESSAGE,
  redirectRoutesAfterPayment,
  showErrorValuesDefault,
  showErrorValuesSubmit,
  SUCCESS_MESSAGE,
} from '../../../../data/constants/paiement';
import {
  formatDataForRapatriementRenewal,
  sendInfo,
} from '../../../../data/factory/paiement';
import {
  IAirtelMoney,
  IAirtelMoneyError,
} from '../../../../data/types/interface/paiement';
import {StackParams} from '../../../../data/types/navigation';
import mapDispatchToProps from '../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../services/redux/mapStateToProps';
import SubmitButtons from '../../../components/Button/SecondaryButton';
import {HeaderScreen} from '../../../components/Header/HeaderScreen';
import {InputDatePicker} from '../../../components/Inputs/InputDatePicker';
import {InputField} from '../../../components/Inputs/InputField';
import LoaderWithMessage from '../../../components/LoaderWithMessage';
import ConfirmationModal from '../../../components/Modal/ConfirmationModal';
import {PageContainer} from '../../../components/PageContainer';

type NavigationProps = StackNavigationProp<StackParams, 'AirtelPayment'>;

export const AirtelPaymentForm = (props: any) => {
  const {airtelmoneyUser, airtelmoneyTransactionUser, user} = props;
  const {contratEC = {}} = props?.user || {};
  const [showInfoModal, setShowInfoModal] = useState(false);
  const {navigate, goBack} = useNavigation<NavigationProps>();
  const primTTC = contratEC.primeTTC || contratEC.montant || 0;
  const premierVersement = contratEC.premierVersement
    ? contratEC.premierVersement
    : 0;
  const [transactionId, setTransactionId] = useState<string>('');

  const nextDay: Date = React.useMemo(() => {
    return (
      dayjs(contratEC.dateEffet).toDate() ||
      dayjs(contratEC.dateDebut).toDate() ||
      getNextDay(new Date(handleDateValue(contratEC.dateEcheance)))
    );
  }, [contratEC]);

  const [values, setValues] = React.useState<IAirtelMoney>({
    numero: '',
    montant:
      contratEC.typeContrat === undefined &&
      contratEC.typePayment !== 'prime' &&
      contratEC.typePayment !== 'renouvellement'
        ? 0
        : contratEC.typeContrat === 'retraite'
        ? premierVersement
        : primTTC,
    motif: '',
    typeContrat: contratEC.typeContrat,
    simulationId: contratEC.simulationId,
    numeroPolice: contratEC.numeroPolice,
    dateEffet: nextDay.toString() || '',
  });
  const [error, setError] = React.useState<IAirtelMoneyError>(
    defaultAirtelMoneyErrorValues,
  );
  const [showErrors, setShowErrors] = useState(showErrorValuesDefault);
  const [IsLoading, setIsLoading] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [infoMessage, setInfoMessage] = useState('');
  const handleCancel = () => {
    goBack();
  };
  const showInfoMessage = (message: string) => {
    setInfoMessage(message);
    setShowInfoModal(true);
  };

  const sendPayment = () => {
    const contrat = user && user.contratEC && user.contratEC.typeContrat;
    if (
      contrat === 'retraite' ||
      (contratEC.typeContratPayment === 'retraite' &&
        (contratEC.primeTTC === '' || contratEC.typeContrat === undefined))
    ) {
      values.typeContrat = 'retraite';
      values.simulationId = contratEC.simulationId;
    } else {
      values.typeContrat = getTypeContratPayment(
        contrat,
        contratEC?.typeContratPayment,
      );
    }
    values.numero = values.numero.substring(1);
    values.montant = +values.montant.toString().replace(/[^0-9]/g, '');

    const extraInformation =
      values.typeContrat == 'rapatriement'
        ? formatDataForRapatriementRenewal(contratEC)
        : {};

    airtelmoneyUser(
      {
        ...values,
        typePayment: contratEC.typePayment ?? '',
        dateEffet: values.dateEffet
          ? dayjs(values.dateEffet).isValid()
            ? dayjs(values.dateEffet).format('DD/MM/YYYY')
            : values.dateEffet
          : dayjs().format('DD/MM/YYYY'),
        numeroPolice:
          contratEC.typePayment == 'renouvellement'
            ? props.user.numeroPolice
            : '',
        ...extraInformation,
      },
      (res: any) => {
        if (res?.airtelResponse) {
          if (res?.airtelResponse?.data?.transactionId) {
            setTimeout(() => {
              sendTransaction(res.airtelResponse.data.transactionId);
            }, 30 * 1000);
          } else {
            setIsLoading(false);
            setErrorMessage('Erreur sur le paiement');
            setShowErrorModal(true);
          }
        }
      },
    );
  };
  const showErrorMessage = (message: string) => {
    setErrorMessage(message);
    setShowErrorModal(true);
  };

  const sendTransaction = (transactionId: string) => {
    airtelmoneyTransactionUser(
      {},
      (res: any) => {
        console.log(res, 126);
        if (res?.airtelTransactionResponse.data) {
          setTransactionId(() => transactionId);
          showInfoMessage(SUCCESS_MESSAGE);
        } else {
          showErrorMessage(
            res?.airtelTransactionResponse?.message || ERROR_MESSAGE,
          );
        }
        setIsLoading(false);
      },
      `/${transactionId}`,
    );
  };
  const handleSubmit = () => {
    setShowErrors(showErrorValuesSubmit);
    setError(Validation(contratEC, values));
    if (noError(Validation(contratEC, values))) {
      setIsLoading(true);
      sendPayment();
    }
  };

  const redirectToHome = (paramsSend: any) => {
    setIsLoading(false);
    const route = redirectRoutesAfterPayment[paramsSend.title];

    if (route) {
      navigate(route, {id: paramsSend.id});
    } else if (paramsSend.numeroPolice) {
      navigate('DetailContrat', paramsSend);
    } else {
      navigate('Home');
    }
  };
  const infoOkCompletion = () => {
    setShowInfoModal(false);
    setIsLoading(true);
    sendInfo({
      ...props,
      user: {
        ...props.user,
        contratEC: {
          ...props.user.contratEC,
          dateEffet: values.dateEffet,
          transactionId,
        },
      },
      okCompletion: redirectToHome,
      showError: showErrorMessage,
      setIsLoading: () => {
        setIsLoading(false);
      },
    });
  };

  const noError = (validate: any) => {
    let bNoError = true;
    Object.values(validate).forEach(element => {
      if (element !== '') {
        bNoError = false;
      }
    });
    return bNoError;
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleChange = (name: string, value: any, fired: boolean) => {
    setShowErrors(prevShowErrors => ({
      ...prevShowErrors,
      numero: false,
      montant: false,
      motif: false,
    }));
    setValues((prevValues: IAirtelMoney) => ({...prevValues, [name]: value}));
    setError(Validation(contratEC, {...values, [name]: value}));
  };
  const backToMonEspace = () => {
    setShowErrorModal(false);
    navigate('MonEspace');
  };

  useFocusEffect(
    React.useCallback(() => {
      setValues({
        numero: '',
        montant:
          contratEC.typeContrat === undefined &&
          contratEC.typePayment !== 'prime' &&
          contratEC.typePayment !== 'renouvellement'
            ? 0
            : contratEC.typeContrat === 'retraite'
            ? premierVersement
            : primTTC,
        motif: '',
        typeContrat: contratEC.typeContrat,
        simulationId: contratEC.simulationId,
        numeroPolice: contratEC.numeroPolice,
        dateEffet:
          contratEC.typePayment === 'souscription'
            ? contratEC.dateEffet
            : nextDay.toISOString() || '',
      });
    }, [contratEC]),
  );

  return (
    <View>
      <HeaderScreen title="Airtel" type="retour" noBreadcrumb={false} />
      <PageContainer>
        <LoaderWithMessage isLoading={IsLoading} />
        {!IsLoading && (
          <View>
            <View>
              <InputField
                label="Numéro de téléphone"
                required
                value={values.numero}
                name="numero"
                type="telephone"
                onChange={handleChange}
                error={error.numero}
                showError={showErrors.numero}
                maxLength={70}
              />
              <InputField
                label={
                  contratEC.typeContrat === undefined &&
                  contratEC.typePayment === 'cotisation'
                    ? 'Montant (minimum : 2000 Ar)'
                    : 'Montant (Ar)'
                }
                required
                value={
                  values.montant === 0 ? '' : separateurMillier(values.montant)
                }
                name="montant"
                type="price"
                onChange={handleChange}
                error={error.montant}
                showError={showErrors.montant}
                isEditable={
                  contratEC.typePayment === 'cotisation' ||
                  contratEC.typeContrat === 'retraite' ||
                  !!config.montantEditable
                }
              />
              {contratEC.typeContrat != 'rcvp' &&
              contratEC.typeContrat != 'scolaire' &&
              contratEC.typeContrat != 'rattache' &&
              (contratEC.typePayment === 'prime' ||
                contratEC.typePayment === 'renouvellement') ? (
                <InputDatePicker
                  label={"Date d'effet"}
                  required
                  value={values.dateEffet}
                  name="dateEffet"
                  onChange={handleChange}
                  dateMin={getNextDay(
                    new Date(handleDateValue(contratEC.dateEcheance)),
                  )}
                  isEditable={!(contratEC.typePayment != 'rapatriement')}
                />
              ) : null}
              <InputField
                label="Motif"
                required
                value={values.motif}
                name="motif"
                onChange={handleChange}
                error={error.motif}
                showError={showErrors.motif}
                maxLength={20}
              />
            </View>
            <View>
              <SubmitButtons
                cancelAction={handleCancel}
                submitAction={handleSubmit}
                cancelTitle="Annuler"
                submitTitle="Valider"
              />
            </View>
          </View>
        )}

        {/** Error modal */}
        {showErrorModal && (
          <ConfirmationModal
            title="Erreur"
            content={errorMessage}
            btn1="OK"
            handleBtn1={backToMonEspace}
          />
        )}
        {showInfoModal && (
          <ConfirmationModal
            title="Information"
            content={infoMessage}
            btn1="OK"
            handleBtn1={infoOkCompletion}
          />
        )}
      </PageContainer>
    </View>
  );
};

export const AirtelPayment: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AirtelPaymentForm);
